export default __webpack_public_path__ + "static/char-52-anr-21e765f6f72f7f44724a346dd57cfb97.webp";